/**
 * Collection of routes available within the application.
 */
export const routes = {
    block: "/:blockId.html",
};
